module.exports = __webpack_public_path__ + "static/media/glip_icon_blue.b3d4ee30.svg";